'use client';

import React, { useEffect, useState } from 'react';

import { cn } from '@/lib/utils/cn';

export default function BackgroundGridWrapper({ children, className }) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <>
      <div className="pointer-events-none absolute inset-0 grid h-full grid-cols-8 border-black/10 px-[5%]">
        <div
          className={cn(
            'col-span-1 h-full w-full border-x-[0.1px] border-y-0 border-black/5 transition-[height] duration-3000 ease-in-out',
            className,
            isVisible ? 'h-full' : 'h-0',
          )}
          style={{ transitionDelay: '2000ms' }} // Delay for 1 second
        ></div>

        <div
          className={cn(
            'col-span-1 h-full w-full border-r-[0.1px] border-black/5 transition-[height] duration-3000 ease-in-out',
            className,
            isVisible ? 'h-full' : 'h-0',
          )}
          style={{ transitionDelay: '2200ms' }}
        ></div>
        <div
          className={cn(
            'col-span-1 h-full w-full border-r-[0.1px] border-black/5 transition-[height] duration-3000 ease-in-out',
            className,
            isVisible ? 'h-full' : 'h-0',
          )}
          style={{ transitionDelay: '2400ms' }}
        ></div>
        <div
          className={cn(
            'col-span-1 h-full w-full border-r-[0.1px] border-black/5 transition-[height] duration-3000 ease-in-out',
            className,
            isVisible ? 'h-full' : 'h-0',
          )}
          style={{ transitionDelay: '2600ms' }}
        ></div>
        <div
          className={cn(
            'col-span-1 h-full w-full border-r-[0.1px] border-black/5 transition-[height] duration-3000 ease-in-out',
            className,
            isVisible ? 'h-full' : 'h-0',
          )}
          style={{ transitionDelay: '2800ms' }}
        ></div>
        <div
          className={cn(
            'col-span-1 h-full w-full border-r-[0.1px] border-black/5 transition-[height] duration-3000 ease-in-out',
            className,
            isVisible ? 'h-full' : 'h-0',
          )}
          style={{ transitionDelay: '3000ms' }}
        ></div>
        <div
          className={cn(
            'col-span-1 h-full w-full border-r-[0.1px] border-black/5 transition-[height] duration-3000 ease-in-out',
            className,
            isVisible ? 'h-full' : 'h-0',
          )}
          style={{ transitionDelay: '3200ms' }}
        ></div>
        <div
          className={cn(
            'col-span-1 h-full w-full border-r-[0.1px] border-black/5 transition-[height] duration-3000 ease-in-out',
            className,
            isVisible ? 'h-full' : 'h-0',
          )}
          style={{ transitionDelay: '3400ms' }}
        ></div>
      </div>
      {children}
    </>
  );
}
